import styled from "styled-components";
import theme from "../../style/theme";

interface Props {
  width: string;
  height: string;
  text: string;
  onClick: () => void;
}

export const ContainedGrayButton: React.FC<Props> = ({
  width,
  height,
  text,
  onClick,
}) => {
  return (
    <PrimaryButton width={width} height={height} onClick={onClick}>
      {text}
    </PrimaryButton>
  );
};

interface PrimaryButtonProps {
  width: string;
  height: string;
}

const PrimaryButton = styled.button<PrimaryButtonProps>`
width: ${(props) => props.width}};
    height: ${(props) => props.height}};
  background: ${theme.palette.primitives.gray50};
  border: 1px solid ${theme.palette.primitives.gray50};
  border-radius: 4px;
  padding: 1rem 1.5rem;
  font-style: normal;
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.188rem;
  color: ${theme.palette.primitives.black};
  cursor: pointer;
`;
